import { render, staticRenderFns } from "./CustomerContractAdd.vue?vue&type=template&id=d23a77c4"
import script from "./CustomerContractAdd.vue?vue&type=script&lang=js"
export * from "./CustomerContractAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports